// extracted by mini-css-extract-plugin
export var searchHeader = "_as-0";
export var searchHeaderDark = "_as-1";